export default __webpack_public_path__ + "static/media/creeper_map.2ee957fa.png";